<script setup>
import Slider from "@vueform/slider";

const props = defineProps({
  step: {
    type: Number,
    default: 1,
  },
});

const sliderValues = defineModel("values", {
  type: Array,
  required: true,
  default: [20, 40],
});

const minProp = defineModel("min", {
  type: Number,
  default: 0,
});

const maxProp = defineModel("max", {
  type: Number,
  default: 100,
});

const formatNumber = (num) => {
  if (!num && num !== 0) return "";
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

const parseNumber = (str) => {
  if (!str) return 0;
  return parseInt(str.replace(/,/g, ""), 10);
};

const minValue = ref(formatNumber(sliderValues.value[0]));
const maxValue = ref(formatNumber(sliderValues.value[1]));

watch(
  () => sliderValues.value,
  (newVal) => {
    minValue.value = formatNumber(newVal[0]);
    maxValue.value = formatNumber(newVal[1]);
  },
  { deep: true }
);

const updateMin = (e) => {
  const parsed = parseNumber(e.target.value);
  if (parsed >= minProp.value && parsed <= sliderValues.value[1]) {
    sliderValues.value = [parsed, sliderValues.value[1]];
  }
};

const updateMax = (e) => {
  const parsed = parseNumber(e.target.value);
  if (parsed <= maxProp.value && parsed >= sliderValues.value[0]) {
    sliderValues.value = [sliderValues.value[0], parsed];
  }
};
</script>

<template>
  <div class="flex flex-col gap-6 min-w-full">
    <Slider
      v-model="sliderValues"
      :min="minProp"
      :max="maxProp"
      :step="step"
      :format="formatNumber"
      class="w-full" />
    <div
      class="mt-4 grid grid-cols-[150px_20px_150px] items-center gap-4 text-neutral-200">
      <div class="relative">
        <input
          type="text"
          :value="minValue"
          @input="updateMin"
          class="w-full py-2 border-0 outline-hidden bg-transparent text-sm focus:ring-0" />
        <label
          class="absolute -top-4 left-0 text-xs transition-all text-neutral-200"
          >Min</label
        >
        <div class="absolute bottom-0 left-0 w-full h-px bg-neutral-200"></div>
      </div>
      <p class="text-neutral-400 text-xs">to</p>
      <div class="relative">
        <input
          type="text"
          :value="maxValue"
          @input="updateMax"
          class="w-full py-2 border-0 outline-hidden bg-transparent text-sm focus:ring-0" />
        <label
          class="absolute -top-4 left-0 text-xs transition-all text-neutral-200"
          >Max</label
        >
        <div class="absolute bottom-0 left-0 w-full h-px bg-neutral-200"></div>
      </div>
    </div>
  </div>
</template>

<style src="@vueform/slider/themes/default.css"></style>

<style>
/* We need to add the peer class to make the focus styles work */
input:focus + label {
  color: #FFFFFF;
}

input:focus ~ div {
  height: 2px;
  background-color: #ffffff;
}

.slider-container {
  width: 100%;
}
</style>
